import { fileService } from './api';

// Cache para tags predefinidos de categoría 2 (verde)
let category2TagsCache = null;
let loadingPromise = null;

/**
 * Obtiene los tags de categoría 2 (verde) desde el cache o los carga si no están disponibles
 * @returns {Promise<string[]>} Array de tags de categoría 2
 */
export const getCategory2Tags = async () => {
  // Si ya están en cache, devolver inmediatamente
  if (category2TagsCache) {
    return category2TagsCache;
  }
  
  // Si ya hay una carga en progreso, esperar a que termine
  if (loadingPromise) {
    return loadingPromise;
  }
  
  // Cargar los tags predefinidos
  loadingPromise = fileService.getPredefinedFolderTags()
    .then(response => {
      category2TagsCache = response.category2 || [];
      console.log('📋 Cache: Tags categoría 2 cargados y cacheados:', category2TagsCache.length);
      return category2TagsCache;
    })
    .catch(err => {
      console.error('❌ Cache: Error cargando tags categoría 2:', err);
      category2TagsCache = []; // Cache vacío en caso de error
      return category2TagsCache;
    })
    .finally(() => {
      loadingPromise = null;
    });
  
  return loadingPromise;
};

/**
 * Precarga los tags de categoría 2 en el cache
 * Útil para cargar los tags al inicio de la aplicación
 */
export const preloadCategory2Tags = () => {
  if (!category2TagsCache && !loadingPromise) {
    getCategory2Tags();
  }
};

/**
 * Limpia el cache (útil para testing o recargar)
 */
export const clearCategory2TagsCache = () => {
  category2TagsCache = null;
  loadingPromise = null;
};

